/* FRØYA GOURMET — froya-bildevern.js v1 (26.10.2026)

   Hindrer de vanlige snarveiene til å hente ut bilder på hele siden:
     * Høyreklikk / langt trykk på et bilde (eller noe som ligger oppå et bilde)
       gir ingen meny, dermed ingen «Lagre bilde som…» og ingen «Åpne bilde i ny fane».
     * Drag-og-slipp av bilder (til skrivebordet, til en ny fane) stoppes.
     * Video: skjuler nedlastingsknappen i nettleserens egen avspiller.
   Vanlig tekst, skjemafelt og lenker uten bilde er upåvirket, så høyreklikk der virker som før.

   Ærlig om grensene: dette stopper nysgjerrige og vanlig kopiering. Det stopper ikke
   skjermbilde, utviklerverktøy eller noen som vil tvinge det. Bildene kan ikke gjøres
   skjult for nettleseren — den må laste dem for å vise dem.
*/
(function () {
  'use strict';
  if (window.__fgBildevern) return;
  window.__fgBildevern = true;

  var BILDE = 'img,picture,video,canvas';
  var SKJEMA = 'input,textarea,select,[contenteditable="true"],[contenteditable=""]';

  function harBakgrunnsbilde(el) {
    try {
      return /url\(/.test(getComputedStyle(el).backgroundImage || '');
    } catch (e) {
      return false;
    }
  }

  /* Ligger det et bilde (eller bakgrunnsbilde) under pekeren, selv bak overlegg? */
  function paaBilde(e) {
    var t = e.target;
    if (!(t instanceof Element)) return false;
    if (t.closest(SKJEMA)) return false;
    if (t.closest(BILDE + ',.fg-zoom,[data-fg-vern]')) return true;
    if (typeof e.clientX === 'number' && document.elementsFromPoint) {
      var stabel = document.elementsFromPoint(e.clientX, e.clientY);
      for (var i = 0; i < stabel.length && i < 8; i++) {
        var el = stabel[i];
        if (el.matches && el.matches(BILDE)) return true;
        if (harBakgrunnsbilde(el)) return true;
      }
    }
    return false;
  }

  document.addEventListener(
    'contextmenu',
    function (e) {
      if (paaBilde(e)) e.preventDefault();
    },
    true
  );

  document.addEventListener(
    'dragstart',
    function (e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.matches(BILDE) || (t.matches('a') && t.querySelector(BILDE))) e.preventDefault();
    },
    true
  );

  function video(rot) {
    [].forEach.call((rot || document).querySelectorAll('video'), function (v) {
      v.setAttribute('controlslist', 'nodownload noremoteplayback');
      v.setAttribute('disablepictureinpicture', '');
    });
  }
  video(document);
  if ('MutationObserver' in window) {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        if (ms[i].addedNodes.length) { video(document); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
